/**
 * Species-related utilitie
 */
import { ApiFilter } from "@result/rui/utils/api";

export const GOATS = "GOATS";
export const SHEEPS = "SHEEPS";
export const HORSES = "HORSES";
export const PIGS = "PIGS";
export const CATTLE = "CATTLE";

const sl = {
  KOZA: GOATS,
  OVCA: SHEEPS,
  KONJ: HORSES,
  PRASIC: PIGS,
  GOVEDO: CATTLE,
};

const en = Object.entries(sl).reduce((acc, [key, value]) => {
  acc[value] = key;
  return acc;
}, {});

const list = [GOATS, SHEEPS, HORSES, PIGS, CATTLE];

// default all species by default
let enabled = list;

/**
 * Set the species filter. Only valid species will be accepted.
 *
 * @param  {...string} species
 */
export function set(...species) {
  enabled = [];

  for (const s of species) {
    if (list.includes(s)) {
      enabled.push(s);
    }
  }
}

/**
 * Get the list of currently filtered species.
 *
 * @returns {Array<string>}
 */
export function get() {
  return enabled;
}

export function getTranslated() {
  return enabled.map((s) => en[s]);
}

/**
 * Check if a species is currently filtered.
 *
 * @param {string} species
 * @returns {boolean}
 */
export function has(species) {
  return enabled.includes(species) || enabled.includes(sl[species]);
}

/**
 * Build a filter for all currently selected species.
 *
 * We'll be working with species codes (OVCA, KONJ, ...) in the backend,
 * so we need to map our species to their corresponding codes.
 *
 * Examples:
 *  (1) Use it as the only (or first filter) to get all relevant breeds:
 *      filter = species.filter()
 *
 *  (2) Use it to add species filtering to an existing filter:
 *      filter = species.filter("species", existingFilter)
 *
 *  (3) Use it to filter by a different field (e.g. "speciesPotomca" for breed compositions):
 *     filter = species.filter("speciesPotomca", existingFilter)
 *
 * @param {string} field - the field to apply the filter on, default is "species"
 * @param {object} base - filter to build upon
 */
export function filter(field = "species", f = new ApiFilter()) {
  return f.or((or) => {
    list.filter(has).forEach((key) => {
      or.where(field, "EQ", en[key]);
    });
  });
}
